/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIDtosBookingDataPatchDTO,
  RightioWBSAPIDtosVersionDTO,
  RightioWBSAPIModelsWEBApiLog,
  RightioWBSAPIModelsWEBBookingArchive,
  RightioWBSAPIModelsWEBBookingData,
  RightioWBSAPIModelsWEBGeneralLog,
  WebBookingDataGetVersionsParams
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves all API log records from the system monitoring database for analysis and auditing.
 * @summary Get all Api Logs
 */
export const webApiLogGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBApiLog[]>(
      {url: `/api/ApiLog`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new API log record with automatic client information detection for monitoring and auditing.
 * @summary Create Api Log
 */
export const webApiLogCreate = (
    rightioWBSAPIModelsWEBApiLog: BodyType<RightioWBSAPIModelsWEBApiLog>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBApiLog>(
      {url: `/api/ApiLog`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBApiLog
    },
      options);
    }
  /**
 * Retrieves a specific API log record by ID for detailed monitoring and debugging analysis.
 * @summary Get Api Log by Id
 */
export const webApiLogGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBApiLog>(
      {url: `/api/ApiLog/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Permanently deletes an API log record from the monitoring system. Use with caution for audit compliance.
 * @summary Delete Api Log by Id
 */
export const webApiLogDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ApiLog/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Creates multiple API log records in a single batch operation for efficient bulk logging and monitoring.
 * @summary Create Many Api Logs
 */
export const webApiLogCreateMany = (
    rightioWBSAPIModelsWEBApiLog: RightioWBSAPIModelsWEBApiLog[],
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ApiLog/Many`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBApiLog
    },
      options);
    }
  /**
 * Retrieves all booking archive records from the historical data storage system for audit trails and compliance.
 * @summary Get all Booking Archives
 */
export const webBookingArchivesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingArchive[]>(
      {url: `/api/BookingArchives`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new booking archive record for historical data preservation and regulatory compliance.
 * @summary Create Booking Archive
 */
export const webBookingArchivesCreate = (
    rightioWBSAPIModelsWEBBookingArchive: BodyType<RightioWBSAPIModelsWEBBookingArchive>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingArchive>(
      {url: `/api/BookingArchives`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBBookingArchive
    },
      options);
    }
  /**
 * Retrieves a specific booking archive record by job ID for historical data access and audit trails.
 * @summary Get Booking Archive by Id
 */
export const webBookingArchivesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingArchive>(
      {url: `/api/BookingArchives/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing booking archive record for data correction and administrative maintenance.
 * @summary Update Booking Archive
 */
export const webBookingArchivesUpdate = (
    id: number,
    rightioWBSAPIModelsWEBBookingArchive: BodyType<RightioWBSAPIModelsWEBBookingArchive>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/BookingArchives/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBBookingArchive
    },
      options);
    }
  /**
 * Permanently deletes a booking archive record from historical data storage. Use with caution for compliance.
 * @summary Delete Booking Archive
 */
export const webBookingArchivesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/BookingArchives/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all booking data records from the web system for administrative review and synchronization.
 * @summary Get all Booking Data
 */
export const webBookingDataGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingData[]>(
      {url: `/api/BookingData`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new booking data record with comprehensive state validation and conflict resolution capabilities.
 * @summary Create new booking data
 */
export const webBookingDataCreate = (
    rightioWBSAPIModelsWEBBookingData: BodyType<RightioWBSAPIModelsWEBBookingData>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingData>(
      {url: `/api/BookingData`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBBookingData
    },
      options);
    }
  /**
 * Retrieves a specific booking data record by job ID with comprehensive state management and synchronization capabilities.
 * @summary Get Booking Data by Id
 */
export const webBookingDataGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingData>(
      {url: `/api/BookingData/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing booking data record with comprehensive state validation and synchronization management.
 * @summary Update Booking Data
 */
export const webBookingDataUpdate = (
    id: number,
    rightioWBSAPIDtosBookingDataPatchDTO: BodyType<RightioWBSAPIDtosBookingDataPatchDTO>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBBookingData>(
      {url: `/api/BookingData/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIDtosBookingDataPatchDTO
    },
      options);
    }
  /**
 * Deletes a booking data record with comprehensive archival and state management for safe data lifecycle management.
 * @summary Delete Booking Data
 */
export const webBookingDataDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/BookingData/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves booking data versions for a specific user with live system synchronization and comprehensive version tracking.
 * @summary Get booking data versions
 */
export const webBookingDataGetVersions = (
    params: WebBookingDataGetVersionsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIDtosVersionDTO[]>(
      {url: `/api/BookingData/Versions`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieves all general log records from the system monitoring database for comprehensive analysis and auditing.
 * @summary Get all General Logs
 */
export const webGeneralLogGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBGeneralLog[]>(
      {url: `/api/GeneralLog`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new general log record with automatic client information detection for system monitoring.
 * @summary Create General Log
 */
export const webGeneralLogCreate = (
    rightioWBSAPIModelsWEBGeneralLog: BodyType<RightioWBSAPIModelsWEBGeneralLog>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBGeneralLog>(
      {url: `/api/GeneralLog`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBGeneralLog
    },
      options);
    }
  /**
 * Retrieves a specific general log record by ID for detailed event analysis and debugging.
 * @summary Get General Log by Id
 */
export const webGeneralLogGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsWEBGeneralLog>(
      {url: `/api/GeneralLog/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Permanently deletes a general log record from the monitoring system. Use with caution for audit compliance.
 * @summary Delete General Log by Id
 */
export const webGeneralLogDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/GeneralLog/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Creates multiple general log records in a single batch operation for efficient bulk logging and monitoring.
 * @summary Create Many General Logs
 */
export const webGeneralLogCreateMany = (
    rightioWBSAPIModelsWEBGeneralLog: RightioWBSAPIModelsWEBGeneralLog[],
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/GeneralLog/Many`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsWEBGeneralLog
    },
      options);
    }
  export type WebApiLogGetAllResult = NonNullable<Awaited<ReturnType<typeof webApiLogGetAll>>>
export type WebApiLogCreateResult = NonNullable<Awaited<ReturnType<typeof webApiLogCreate>>>
export type WebApiLogGetByIdResult = NonNullable<Awaited<ReturnType<typeof webApiLogGetById>>>
export type WebApiLogDeleteResult = NonNullable<Awaited<ReturnType<typeof webApiLogDelete>>>
export type WebApiLogCreateManyResult = NonNullable<Awaited<ReturnType<typeof webApiLogCreateMany>>>
export type WebBookingArchivesGetAllResult = NonNullable<Awaited<ReturnType<typeof webBookingArchivesGetAll>>>
export type WebBookingArchivesCreateResult = NonNullable<Awaited<ReturnType<typeof webBookingArchivesCreate>>>
export type WebBookingArchivesGetByIdResult = NonNullable<Awaited<ReturnType<typeof webBookingArchivesGetById>>>
export type WebBookingArchivesUpdateResult = NonNullable<Awaited<ReturnType<typeof webBookingArchivesUpdate>>>
export type WebBookingArchivesDeleteResult = NonNullable<Awaited<ReturnType<typeof webBookingArchivesDelete>>>
export type WebBookingDataGetAllResult = NonNullable<Awaited<ReturnType<typeof webBookingDataGetAll>>>
export type WebBookingDataCreateResult = NonNullable<Awaited<ReturnType<typeof webBookingDataCreate>>>
export type WebBookingDataGetByIdResult = NonNullable<Awaited<ReturnType<typeof webBookingDataGetById>>>
export type WebBookingDataUpdateResult = NonNullable<Awaited<ReturnType<typeof webBookingDataUpdate>>>
export type WebBookingDataDeleteResult = NonNullable<Awaited<ReturnType<typeof webBookingDataDelete>>>
export type WebBookingDataGetVersionsResult = NonNullable<Awaited<ReturnType<typeof webBookingDataGetVersions>>>
export type WebGeneralLogGetAllResult = NonNullable<Awaited<ReturnType<typeof webGeneralLogGetAll>>>
export type WebGeneralLogCreateResult = NonNullable<Awaited<ReturnType<typeof webGeneralLogCreate>>>
export type WebGeneralLogGetByIdResult = NonNullable<Awaited<ReturnType<typeof webGeneralLogGetById>>>
export type WebGeneralLogDeleteResult = NonNullable<Awaited<ReturnType<typeof webGeneralLogDelete>>>
export type WebGeneralLogCreateManyResult = NonNullable<Awaited<ReturnType<typeof webGeneralLogCreateMany>>>
